module.exports = __webpack_public_path__ + "static/media/ab67616d0000b27382eabf564ddc57325a84dd50-394x394.ceb5cef0.jpg";